module.exports = __webpack_public_path__ + "static/media/eyes.4d912008.svg";